import { render } from "./TestContainer.vue?vue&type=template&id=abd7c076"
import script from "./TestContainer.vue?vue&type=script&lang=js"
export * from "./TestContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__